import { LineString, Polygon, Point, Feature } from "geojson";

export type AnySupportedGeometry = LineString | Polygon | Point;

export type AnyFeature = Feature<AnySupportedGeometry>;
